import {
  START_REQUEST,
  STOP_REQUEST,
  FETCH_INVOICES_START,
  FETCH_INVOICES_SUCCESS,
  FETCH_INVOICES_FAILURE,
} from '../actions/paymentActions';

export default (state = { invoices: [], hasMoreInvoices: false, loading: false, invoicesError: false }, action) => {
  switch (action.type) {
  case START_REQUEST: {
    return {
      ...state,
      loading: true,
    };
  }
  case STOP_REQUEST: {
    return {
      ...state,
      loading: false,
    };
  }
  case FETCH_INVOICES_START: {
    return {
      ...state,
      loading: true,
      invoicesError: false,
    };
  }
  case FETCH_INVOICES_SUCCESS: {
    return {
      ...state,
      invoices: action.invoices,
      hasMoreInvoices: action.hasMoreInvoices,
      invoicesError: false,
    };
  }
  case FETCH_INVOICES_FAILURE: {
    return {
      ...state,
      invoicesError: true,
    };
  }
  default:
    return state;
  }
};
